/**
 * Feature flag for the advisory tab.
 */
export const FEATURE_FLAG_ADVISORY = 'advisory' as const;
